import script from "./DesktopNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopNavbar.vue?vue&type=script&setup=true&lang=js"

import "./DesktopNavbar.vue?vue&type=style&index=0&id=c4f24a70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4f24a70"]])

export default __exports__